
import { useTranslation } from "react-i18next";
import { useEffect, useId, useState } from 'react';
import { assetIcons, getAssetIcon, Icon } from './Icon';

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface Properties {
  icon: string;
  iconChanged?: (id: string) => void
}

export const IconSelector = (properties: Properties) => {
  const { t: _t } = useTranslation();
  const [icon, setIcon] = useState(getAssetIcon('fire-extinguisher')) as any;
  const [dialogOpen, setDialogOpen] = useState() as any;
  const filterId = useId();

  useEffect(() => {
    if (!properties.icon) {
      return;
    }

    const newIcon = getAssetIcon(properties.icon);

    setIcon(newIcon);

  }, [properties.icon]);

  return <>
    {/* Die Symbolfläche war eine klickbare div — als Schaltfläche ist sie mit
        Tastatur erreichbar; die Rahmenfarbe kommt weiterhin aus dem Symbol. */}
    <Button
      type="button"
      variant="ghost"
      aria-label="Symbolauswahl"
      className="h-[30px] w-[30px] shrink-0 border bg-background p-0 max-sm:h-11 max-sm:w-11"
      style={{ borderColor: icon.color }}
      onClick={() => setDialogOpen(true)}
    >
      <Icon id={icon.id}></Icon>
    </Button>
    <Dialog
      open={!!dialogOpen}
      onOpenChange={(next) => {
        if (!next) setDialogOpen(false);
      }}
    >
      {/* `isBlocking` des Bestands: ein Klick daneben schließt nicht. */}
      <DialogContent
        className="max-w-none sm:w-[700px] w-[calc(100vw-2rem)]"
        onInteractOutside={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Symbolauswahl</DialogTitle>
        </DialogHeader>
        <div className="flex min-w-0 flex-col gap-4">
          <div className="flex flex-wrap items-center gap-4">
            <Label htmlFor={filterId}>Filter:</Label>
            <Input id={filterId} className="max-w-xs" placeholder='Filter eingeben ...' />
          </div>
          <div className="flex flex-wrap gap-4">
            {assetIcons.map((assetIcon: any) =>
              <Button
                key={assetIcon.id}
                type="button"
                variant="ghost"
                className="flex h-auto w-20 flex-col items-center gap-1 whitespace-normal p-2"
                onClick={() => {
                  setDialogOpen(false);
                  setIcon(assetIcon);

                  if (properties.iconChanged) {
                    properties.iconChanged(assetIcon.id);
                  }
                }}
              >
                <span
                  className="flex h-[30px] w-[30px] items-center justify-center border bg-background"
                  style={{ borderColor: assetIcon.color }}
                >
                  <Icon id={assetIcon.id}></Icon>
                </span>
                <span className="text-center text-xs">{assetIcon.label}</span>
              </Button>)
            }
          </div>
        </div>
      </DialogContent>
    </Dialog>
  </>;
};
